/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AdjustTracker from './AdjustTracker';
import AdminUserMemo from './AdminUserMemo';
import AgentMessageRefusal from './AgentMessageRefusal';
import AssessmentProposal from './AssessmentProposal';
import ConsiderationPeriodEnum from './ConsiderationPeriodEnum';
import ContractApplication from './ContractApplication';
import DegreeOfConsiderationEnum from './DegreeOfConsiderationEnum';
import InvestmentProposal from './InvestmentProposal';
import JobCategory from './JobCategory';
import JobIndustry from './JobIndustry';
import Master from './Master';
import MoneyAmount from './MoneyAmount';
import PastMeetingCountEnum from './PastMeetingCountEnum';
import Period from './Period';
import ProposalMatching from './ProposalMatching';
import ReferralRefEnum from './ReferralRefEnum';
import RegisteredStatusEnum from './RegisteredStatusEnum';
import User from './User';
import UserAccessScreenLogMonthlySummary from './UserAccessScreenLogMonthlySummary';
import UserDeviceToken from './UserDeviceToken';

/**
 * The AiOfferDraftItemUser model module.
 * @module model/AiOfferDraftItemUser
 * @version 1.0.0
 */
class AiOfferDraftItemUser {
    /**
     * Constructs a new <code>AiOfferDraftItemUser</code>.
     * 確認画面のユーザー情報。明細（GET /ai_offer_batches/{id}）でのみ返る
     * @alias module:model/AiOfferDraftItemUser
     * @implements module:model/User
     */
    constructor() { 
        User.initialize(this);
        AiOfferDraftItemUser.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AiOfferDraftItemUser</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferDraftItemUser} obj Optional instance to populate.
     * @return {module:model/AiOfferDraftItemUser} The populated <code>AiOfferDraftItemUser</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferDraftItemUser();
            User.constructFromObject(data, obj);

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('score')) {
                obj['score'] = ApiClient.convertToType(data['score'], 'Number');
            }
            if (data.hasOwnProperty('identifier')) {
                obj['identifier'] = ApiClient.convertToType(data['identifier'], 'String');
            }
            if (data.hasOwnProperty('family_name')) {
                obj['family_name'] = ApiClient.convertToType(data['family_name'], 'String');
            }
            if (data.hasOwnProperty('first_name')) {
                obj['first_name'] = ApiClient.convertToType(data['first_name'], 'String');
            }
            if (data.hasOwnProperty('family_name_kana')) {
                obj['family_name_kana'] = ApiClient.convertToType(data['family_name_kana'], 'String');
            }
            if (data.hasOwnProperty('first_name_kana')) {
                obj['first_name_kana'] = ApiClient.convertToType(data['first_name_kana'], 'String');
            }
            if (data.hasOwnProperty('is_enabled_email_notification')) {
                obj['is_enabled_email_notification'] = ApiClient.convertToType(data['is_enabled_email_notification'], 'Boolean');
            }
            if (data.hasOwnProperty('is_enabled_sms_notification')) {
                obj['is_enabled_sms_notification'] = ApiClient.convertToType(data['is_enabled_sms_notification'], 'Boolean');
            }
            if (data.hasOwnProperty('is_enabled_push_notification')) {
                obj['is_enabled_push_notification'] = ApiClient.convertToType(data['is_enabled_push_notification'], 'Boolean');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phone_number')) {
                obj['phone_number'] = ApiClient.convertToType(data['phone_number'], 'String');
            }
            if (data.hasOwnProperty('birthday')) {
                obj['birthday'] = ApiClient.convertToType(data['birthday'], 'Date');
            }
            if (data.hasOwnProperty('income_tax_rate')) {
                obj['income_tax_rate'] = ApiClient.convertToType(data['income_tax_rate'], 'Number');
            }
            if (data.hasOwnProperty('job_category')) {
                obj['job_category'] = JobCategory.constructFromObject(data['job_category']);
            }
            if (data.hasOwnProperty('address_prefecture')) {
                obj['address_prefecture'] = ApiClient.convertToType(data['address_prefecture'], 'String');
            }
            if (data.hasOwnProperty('job_industry')) {
                obj['job_industry'] = JobIndustry.constructFromObject(data['job_industry']);
            }
            if (data.hasOwnProperty('job_continuous_period')) {
                obj['job_continuous_period'] = Period.constructFromObject(data['job_continuous_period']);
            }
            if (data.hasOwnProperty('estimated_job_continuous_period')) {
                obj['estimated_job_continuous_period'] = ApiClient.convertToType(data['estimated_job_continuous_period'], Period);
            }
            if (data.hasOwnProperty('is_job_continuous_period_estimated')) {
                obj['is_job_continuous_period_estimated'] = ApiClient.convertToType(data['is_job_continuous_period_estimated'], 'Boolean');
            }
            if (data.hasOwnProperty('financial_asset')) {
                obj['financial_asset'] = MoneyAmount.constructFromObject(data['financial_asset']);
            }
            if (data.hasOwnProperty('annual_income')) {
                obj['annual_income'] = ApiClient.convertToType(data['annual_income'], 'Number');
            }
            if (data.hasOwnProperty('holding_property_count')) {
                obj['holding_property_count'] = ApiClient.convertToType(data['holding_property_count'], 'Number');
            }
            if (data.hasOwnProperty('registered_holding_property_count')) {
                obj['registered_holding_property_count'] = ApiClient.convertToType(data['registered_holding_property_count'], 'Number');
            }
            if (data.hasOwnProperty('registered_considering_property_count')) {
                obj['registered_considering_property_count'] = ApiClient.convertToType(data['registered_considering_property_count'], 'Number');
            }
            if (data.hasOwnProperty('real_estate_loan_amount')) {
                obj['real_estate_loan_amount'] = ApiClient.convertToType(data['real_estate_loan_amount'], 'Number');
            }
            if (data.hasOwnProperty('current_residence_type_id')) {
                obj['current_residence_type_id'] = ApiClient.convertToType(data['current_residence_type_id'], 'Number');
            }
            if (data.hasOwnProperty('monthly_rent_payment_amount')) {
                obj['monthly_rent_payment_amount'] = ApiClient.convertToType(data['monthly_rent_payment_amount'], 'Number');
            }
            if (data.hasOwnProperty('home_loan_amount')) {
                obj['home_loan_amount'] = ApiClient.convertToType(data['home_loan_amount'], 'Number');
            }
            if (data.hasOwnProperty('consideration_period')) {
                obj['consideration_period'] = ConsiderationPeriodEnum.constructFromObject(data['consideration_period']);
            }
            if (data.hasOwnProperty('past_meeting_count')) {
                obj['past_meeting_count'] = PastMeetingCountEnum.constructFromObject(data['past_meeting_count']);
            }
            if (data.hasOwnProperty('considering_property')) {
                obj['considering_property'] = ApiClient.convertToType(data['considering_property'], 'String');
            }
            if (data.hasOwnProperty('approved_financial_institutions')) {
                obj['approved_financial_institutions'] = ApiClient.convertToType(data['approved_financial_institutions'], 'String');
            }
            if (data.hasOwnProperty('other_request_text')) {
                obj['other_request_text'] = ApiClient.convertToType(data['other_request_text'], 'String');
            }
            if (data.hasOwnProperty('data_first_registered_status')) {
                obj['data_first_registered_status'] = RegisteredStatusEnum.constructFromObject(data['data_first_registered_status']);
            }
            if (data.hasOwnProperty('request_the_proposal')) {
                obj['request_the_proposal'] = ApiClient.convertToType(data['request_the_proposal'], 'Boolean');
            }
            if (data.hasOwnProperty('way_to_propose')) {
                obj['way_to_propose'] = ApiClient.convertToType(data['way_to_propose'], 'Number');
            }
            if (data.hasOwnProperty('degree_of_consideration_for_investment')) {
                obj['degree_of_consideration_for_investment'] = DegreeOfConsiderationEnum.constructFromObject(data['degree_of_consideration_for_investment']);
            }
            if (data.hasOwnProperty('degree_of_consideration_for_sale')) {
                obj['degree_of_consideration_for_sale'] = DegreeOfConsiderationEnum.constructFromObject(data['degree_of_consideration_for_sale']);
            }
            if (data.hasOwnProperty('purpose_of_use_free_text')) {
                obj['purpose_of_use_free_text'] = ApiClient.convertToType(data['purpose_of_use_free_text'], 'String');
            }
            if (data.hasOwnProperty('inflow_route_free_text')) {
                obj['inflow_route_free_text'] = ApiClient.convertToType(data['inflow_route_free_text'], 'String');
            }
            if (data.hasOwnProperty('email_confirmed')) {
                obj['email_confirmed'] = ApiClient.convertToType(data['email_confirmed'], 'Boolean');
            }
            if (data.hasOwnProperty('last_seen_announcement_id')) {
                obj['last_seen_announcement_id'] = ApiClient.convertToType(data['last_seen_announcement_id'], 'Number');
            }
            if (data.hasOwnProperty('has_unread_announcements')) {
                obj['has_unread_announcements'] = ApiClient.convertToType(data['has_unread_announcements'], 'Boolean');
            }
            if (data.hasOwnProperty('is_diagnosis_complete')) {
                obj['is_diagnosis_complete'] = ApiClient.convertToType(data['is_diagnosis_complete'], 'Boolean');
            }
            if (data.hasOwnProperty('is_investment_style_diagnosis_complete')) {
                obj['is_investment_style_diagnosis_complete'] = ApiClient.convertToType(data['is_investment_style_diagnosis_complete'], 'Boolean');
            }
            if (data.hasOwnProperty('is_ad_measurement_test')) {
                obj['is_ad_measurement_test'] = ApiClient.convertToType(data['is_ad_measurement_test'], 'Boolean');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('password_confirmation')) {
                obj['password_confirmation'] = ApiClient.convertToType(data['password_confirmation'], 'String');
            }
            if (data.hasOwnProperty('withdrawal_intended_at')) {
                obj['withdrawal_intended_at'] = ApiClient.convertToType(data['withdrawal_intended_at'], 'Date');
            }
            if (data.hasOwnProperty('last_accessed_at')) {
                obj['last_accessed_at'] = ApiClient.convertToType(data['last_accessed_at'], 'Date');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('account_updated_at')) {
                obj['account_updated_at'] = ApiClient.convertToType(data['account_updated_at'], 'Date');
            }
            if (data.hasOwnProperty('account_registered_at')) {
                obj['account_registered_at'] = ApiClient.convertToType(data['account_registered_at'], 'Date');
            }
            if (data.hasOwnProperty('discarded_at')) {
                obj['discarded_at'] = ApiClient.convertToType(data['discarded_at'], 'Date');
            }
            if (data.hasOwnProperty('first_match_at')) {
                obj['first_match_at'] = ApiClient.convertToType(data['first_match_at'], 'Date');
            }
            if (data.hasOwnProperty('read_offers_count')) {
                obj['read_offers_count'] = ApiClient.convertToType(data['read_offers_count'], 'Number');
            }
            if (data.hasOwnProperty('total_access_count')) {
                obj['total_access_count'] = ApiClient.convertToType(data['total_access_count'], 'Number');
            }
            if (data.hasOwnProperty('monthly_access_count')) {
                obj['monthly_access_count'] = ApiClient.convertToType(data['monthly_access_count'], 'Number');
            }
            if (data.hasOwnProperty('monthly_deduplication_access_count')) {
                obj['monthly_deduplication_access_count'] = ApiClient.convertToType(data['monthly_deduplication_access_count'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_sum')) {
                obj['matched_count_sum'] = ApiClient.convertToType(data['matched_count_sum'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_user')) {
                obj['matched_count_user'] = ApiClient.convertToType(data['matched_count_user'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_investment')) {
                obj['matched_count_investment'] = ApiClient.convertToType(data['matched_count_investment'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_assessment')) {
                obj['matched_count_assessment'] = ApiClient.convertToType(data['matched_count_assessment'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_manual')) {
                obj['matched_count_manual'] = ApiClient.convertToType(data['matched_count_manual'], 'Number');
            }
            if (data.hasOwnProperty('learning_completed_count')) {
                obj['learning_completed_count'] = ApiClient.convertToType(data['learning_completed_count'], 'Number');
            }
            if (data.hasOwnProperty('learning_progress_rate')) {
                obj['learning_progress_rate'] = ApiClient.convertToType(data['learning_progress_rate'], 'Number');
            }
            if (data.hasOwnProperty('adjust_network')) {
                obj['adjust_network'] = ApiClient.convertToType(data['adjust_network'], 'String');
            }
            if (data.hasOwnProperty('adjust_tracker')) {
                obj['adjust_tracker'] = AdjustTracker.constructFromObject(data['adjust_tracker']);
            }
            if (data.hasOwnProperty('referral_ref')) {
                obj['referral_ref'] = ReferralRefEnum.constructFromObject(data['referral_ref']);
            }
            if (data.hasOwnProperty('account_register_date')) {
                obj['account_register_date'] = ApiClient.convertToType(data['account_register_date'], 'Date');
            }
            if (data.hasOwnProperty('phone_number_auth_code')) {
                obj['phone_number_auth_code'] = ApiClient.convertToType(data['phone_number_auth_code'], 'Number');
            }
            if (data.hasOwnProperty('assessment_proposals')) {
                obj['assessment_proposals'] = ApiClient.convertToType(data['assessment_proposals'], [AssessmentProposal]);
            }
            if (data.hasOwnProperty('investment_proposals')) {
                obj['investment_proposals'] = ApiClient.convertToType(data['investment_proposals'], [InvestmentProposal]);
            }
            if (data.hasOwnProperty('proposal_matchings')) {
                obj['proposal_matchings'] = ApiClient.convertToType(data['proposal_matchings'], [ProposalMatching]);
            }
            if (data.hasOwnProperty('agent_message_refusals')) {
                obj['agent_message_refusals'] = ApiClient.convertToType(data['agent_message_refusals'], [AgentMessageRefusal]);
            }
            if (data.hasOwnProperty('contract_applications')) {
                obj['contract_applications'] = ApiClient.convertToType(data['contract_applications'], [ContractApplication]);
            }
            if (data.hasOwnProperty('admin_user_memo')) {
                obj['admin_user_memo'] = AdminUserMemo.constructFromObject(data['admin_user_memo']);
            }
            if (data.hasOwnProperty('master_tags')) {
                obj['master_tags'] = ApiClient.convertToType(data['master_tags'], [Master]);
            }
            if (data.hasOwnProperty('master_purpose_of_uses')) {
                obj['master_purpose_of_uses'] = ApiClient.convertToType(data['master_purpose_of_uses'], [Master]);
            }
            if (data.hasOwnProperty('master_interested_property_types')) {
                obj['master_interested_property_types'] = ApiClient.convertToType(data['master_interested_property_types'], [Master]);
            }
            if (data.hasOwnProperty('interest_tag_ids')) {
                obj['interest_tag_ids'] = ApiClient.convertToType(data['interest_tag_ids'], ['Number']);
            }
            if (data.hasOwnProperty('has_investment_experience')) {
                obj['has_investment_experience'] = ApiClient.convertToType(data['has_investment_experience'], 'Boolean');
            }
            if (data.hasOwnProperty('master_inflow_routes')) {
                obj['master_inflow_routes'] = ApiClient.convertToType(data['master_inflow_routes'], [Master]);
            }
            if (data.hasOwnProperty('current_residence_type')) {
                obj['current_residence_type'] = Master.constructFromObject(data['current_residence_type']);
            }
            if (data.hasOwnProperty('purpose_of_use_ids')) {
                obj['purpose_of_use_ids'] = ApiClient.convertToType(data['purpose_of_use_ids'], ['Number']);
            }
            if (data.hasOwnProperty('interested_property_type_ids')) {
                obj['interested_property_type_ids'] = ApiClient.convertToType(data['interested_property_type_ids'], ['Number']);
            }
            if (data.hasOwnProperty('inflow_route_ids')) {
                obj['inflow_route_ids'] = ApiClient.convertToType(data['inflow_route_ids'], ['Number']);
            }
            if (data.hasOwnProperty('user_device_token')) {
                obj['user_device_token'] = UserDeviceToken.constructFromObject(data['user_device_token']);
            }
            if (data.hasOwnProperty('user_access_screen_log_monthly_summaries')) {
                obj['user_access_screen_log_monthly_summaries'] = ApiClient.convertToType(data['user_access_screen_log_monthly_summaries'], [UserAccessScreenLogMonthlySummary]);
            }
            if (data.hasOwnProperty('age')) {
                obj['age'] = ApiClient.convertToType(data['age'], 'Number');
            }
            if (data.hasOwnProperty('is_new_label')) {
                obj['is_new_label'] = ApiClient.convertToType(data['is_new_label'], 'Boolean');
            }
            if (data.hasOwnProperty('is_active')) {
                obj['is_active'] = ApiClient.convertToType(data['is_active'], 'Boolean');
            }
            if (data.hasOwnProperty('is_favorite')) {
                obj['is_favorite'] = ApiClient.convertToType(data['is_favorite'], 'Boolean');
            }
            if (data.hasOwnProperty('loan_amount')) {
                obj['loan_amount'] = ApiClient.convertToType(data['loan_amount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferDraftItemUser</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferDraftItemUser</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['identifier'] && !(typeof data['identifier'] === 'string' || data['identifier'] instanceof String)) {
            throw new Error("Expected the field `identifier` to be a primitive type in the JSON string but got " + data['identifier']);
        }
        // ensure the json data is a string
        if (data['family_name'] && !(typeof data['family_name'] === 'string' || data['family_name'] instanceof String)) {
            throw new Error("Expected the field `family_name` to be a primitive type in the JSON string but got " + data['family_name']);
        }
        // ensure the json data is a string
        if (data['first_name'] && !(typeof data['first_name'] === 'string' || data['first_name'] instanceof String)) {
            throw new Error("Expected the field `first_name` to be a primitive type in the JSON string but got " + data['first_name']);
        }
        // ensure the json data is a string
        if (data['family_name_kana'] && !(typeof data['family_name_kana'] === 'string' || data['family_name_kana'] instanceof String)) {
            throw new Error("Expected the field `family_name_kana` to be a primitive type in the JSON string but got " + data['family_name_kana']);
        }
        // ensure the json data is a string
        if (data['first_name_kana'] && !(typeof data['first_name_kana'] === 'string' || data['first_name_kana'] instanceof String)) {
            throw new Error("Expected the field `first_name_kana` to be a primitive type in the JSON string but got " + data['first_name_kana']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['phone_number'] && !(typeof data['phone_number'] === 'string' || data['phone_number'] instanceof String)) {
            throw new Error("Expected the field `phone_number` to be a primitive type in the JSON string but got " + data['phone_number']);
        }
        // ensure the json data is a string
        if (data['address_prefecture'] && !(typeof data['address_prefecture'] === 'string' || data['address_prefecture'] instanceof String)) {
            throw new Error("Expected the field `address_prefecture` to be a primitive type in the JSON string but got " + data['address_prefecture']);
        }
        // ensure the json data is a string
        if (data['considering_property'] && !(typeof data['considering_property'] === 'string' || data['considering_property'] instanceof String)) {
            throw new Error("Expected the field `considering_property` to be a primitive type in the JSON string but got " + data['considering_property']);
        }
        // ensure the json data is a string
        if (data['approved_financial_institutions'] && !(typeof data['approved_financial_institutions'] === 'string' || data['approved_financial_institutions'] instanceof String)) {
            throw new Error("Expected the field `approved_financial_institutions` to be a primitive type in the JSON string but got " + data['approved_financial_institutions']);
        }
        // ensure the json data is a string
        if (data['other_request_text'] && !(typeof data['other_request_text'] === 'string' || data['other_request_text'] instanceof String)) {
            throw new Error("Expected the field `other_request_text` to be a primitive type in the JSON string but got " + data['other_request_text']);
        }
        // ensure the json data is a string
        if (data['purpose_of_use_free_text'] && !(typeof data['purpose_of_use_free_text'] === 'string' || data['purpose_of_use_free_text'] instanceof String)) {
            throw new Error("Expected the field `purpose_of_use_free_text` to be a primitive type in the JSON string but got " + data['purpose_of_use_free_text']);
        }
        // ensure the json data is a string
        if (data['inflow_route_free_text'] && !(typeof data['inflow_route_free_text'] === 'string' || data['inflow_route_free_text'] instanceof String)) {
            throw new Error("Expected the field `inflow_route_free_text` to be a primitive type in the JSON string but got " + data['inflow_route_free_text']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['password_confirmation'] && !(typeof data['password_confirmation'] === 'string' || data['password_confirmation'] instanceof String)) {
            throw new Error("Expected the field `password_confirmation` to be a primitive type in the JSON string but got " + data['password_confirmation']);
        }
        // ensure the json data is a string
        if (data['adjust_network'] && !(typeof data['adjust_network'] === 'string' || data['adjust_network'] instanceof String)) {
            throw new Error("Expected the field `adjust_network` to be a primitive type in the JSON string but got " + data['adjust_network']);
        }
        // validate the optional field `adjust_tracker`
        if (data['adjust_tracker']) { // data not null
          AdjustTracker.validateJSON(data['adjust_tracker']);
        }
        if (data['assessment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['assessment_proposals'])) {
                throw new Error("Expected the field `assessment_proposals` to be an array in the JSON data but got " + data['assessment_proposals']);
            }
            // validate the optional field `assessment_proposals` (array)
            for (const item of data['assessment_proposals']) {
                AssessmentProposal.validateJSON(item);
            };
        }
        if (data['investment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['investment_proposals'])) {
                throw new Error("Expected the field `investment_proposals` to be an array in the JSON data but got " + data['investment_proposals']);
            }
            // validate the optional field `investment_proposals` (array)
            for (const item of data['investment_proposals']) {
                InvestmentProposal.validateJSON(item);
            };
        }
        if (data['proposal_matchings']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['proposal_matchings'])) {
                throw new Error("Expected the field `proposal_matchings` to be an array in the JSON data but got " + data['proposal_matchings']);
            }
            // validate the optional field `proposal_matchings` (array)
            for (const item of data['proposal_matchings']) {
                ProposalMatching.validateJSON(item);
            };
        }
        if (data['agent_message_refusals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['agent_message_refusals'])) {
                throw new Error("Expected the field `agent_message_refusals` to be an array in the JSON data but got " + data['agent_message_refusals']);
            }
            // validate the optional field `agent_message_refusals` (array)
            for (const item of data['agent_message_refusals']) {
                AgentMessageRefusal.validateJSON(item);
            };
        }
        if (data['contract_applications']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contract_applications'])) {
                throw new Error("Expected the field `contract_applications` to be an array in the JSON data but got " + data['contract_applications']);
            }
            // validate the optional field `contract_applications` (array)
            for (const item of data['contract_applications']) {
                ContractApplication.validateJSON(item);
            };
        }
        // validate the optional field `admin_user_memo`
        if (data['admin_user_memo']) { // data not null
          AdminUserMemo.validateJSON(data['admin_user_memo']);
        }
        if (data['master_tags']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['master_tags'])) {
                throw new Error("Expected the field `master_tags` to be an array in the JSON data but got " + data['master_tags']);
            }
            // validate the optional field `master_tags` (array)
            for (const item of data['master_tags']) {
                Master.validateJSON(item);
            };
        }
        if (data['master_purpose_of_uses']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['master_purpose_of_uses'])) {
                throw new Error("Expected the field `master_purpose_of_uses` to be an array in the JSON data but got " + data['master_purpose_of_uses']);
            }
            // validate the optional field `master_purpose_of_uses` (array)
            for (const item of data['master_purpose_of_uses']) {
                Master.validateJSON(item);
            };
        }
        if (data['master_interested_property_types']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['master_interested_property_types'])) {
                throw new Error("Expected the field `master_interested_property_types` to be an array in the JSON data but got " + data['master_interested_property_types']);
            }
            // validate the optional field `master_interested_property_types` (array)
            for (const item of data['master_interested_property_types']) {
                Master.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['interest_tag_ids'])) {
            throw new Error("Expected the field `interest_tag_ids` to be an array in the JSON data but got " + data['interest_tag_ids']);
        }
        if (data['master_inflow_routes']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['master_inflow_routes'])) {
                throw new Error("Expected the field `master_inflow_routes` to be an array in the JSON data but got " + data['master_inflow_routes']);
            }
            // validate the optional field `master_inflow_routes` (array)
            for (const item of data['master_inflow_routes']) {
                Master.validateJSON(item);
            };
        }
        // validate the optional field `current_residence_type`
        if (data['current_residence_type']) { // data not null
          Master.validateJSON(data['current_residence_type']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['purpose_of_use_ids'])) {
            throw new Error("Expected the field `purpose_of_use_ids` to be an array in the JSON data but got " + data['purpose_of_use_ids']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['interested_property_type_ids'])) {
            throw new Error("Expected the field `interested_property_type_ids` to be an array in the JSON data but got " + data['interested_property_type_ids']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['inflow_route_ids'])) {
            throw new Error("Expected the field `inflow_route_ids` to be an array in the JSON data but got " + data['inflow_route_ids']);
        }
        // validate the optional field `user_device_token`
        if (data['user_device_token']) { // data not null
          UserDeviceToken.validateJSON(data['user_device_token']);
        }
        if (data['user_access_screen_log_monthly_summaries']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['user_access_screen_log_monthly_summaries'])) {
                throw new Error("Expected the field `user_access_screen_log_monthly_summaries` to be an array in the JSON data but got " + data['user_access_screen_log_monthly_summaries']);
            }
            // validate the optional field `user_access_screen_log_monthly_summaries` (array)
            for (const item of data['user_access_screen_log_monthly_summaries']) {
                UserAccessScreenLogMonthlySummary.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AiOfferDraftItemUser.prototype['id'] = undefined;

/**
 * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
 * @member {Number} score
 */
AiOfferDraftItemUser.prototype['score'] = undefined;

/**
 * @member {String} identifier
 */
AiOfferDraftItemUser.prototype['identifier'] = undefined;

/**
 * @member {String} family_name
 */
AiOfferDraftItemUser.prototype['family_name'] = undefined;

/**
 * @member {String} first_name
 */
AiOfferDraftItemUser.prototype['first_name'] = undefined;

/**
 * @member {String} family_name_kana
 */
AiOfferDraftItemUser.prototype['family_name_kana'] = undefined;

/**
 * @member {String} first_name_kana
 */
AiOfferDraftItemUser.prototype['first_name_kana'] = undefined;

/**
 * @member {Boolean} is_enabled_email_notification
 */
AiOfferDraftItemUser.prototype['is_enabled_email_notification'] = undefined;

/**
 * @member {Boolean} is_enabled_sms_notification
 */
AiOfferDraftItemUser.prototype['is_enabled_sms_notification'] = undefined;

/**
 * @member {Boolean} is_enabled_push_notification
 * @default true
 */
AiOfferDraftItemUser.prototype['is_enabled_push_notification'] = true;

/**
 * @member {String} email
 */
AiOfferDraftItemUser.prototype['email'] = undefined;

/**
 * @member {String} phone_number
 */
AiOfferDraftItemUser.prototype['phone_number'] = undefined;

/**
 * @member {Date} birthday
 */
AiOfferDraftItemUser.prototype['birthday'] = undefined;

/**
 * @member {Number} income_tax_rate
 */
AiOfferDraftItemUser.prototype['income_tax_rate'] = undefined;

/**
 * @member {module:model/JobCategory} job_category
 */
AiOfferDraftItemUser.prototype['job_category'] = undefined;

/**
 * 住所（都道府県）
 * @member {String} address_prefecture
 */
AiOfferDraftItemUser.prototype['address_prefecture'] = undefined;

/**
 * @member {module:model/JobIndustry} job_industry
 */
AiOfferDraftItemUser.prototype['job_industry'] = undefined;

/**
 * @member {module:model/Period} job_continuous_period
 */
AiOfferDraftItemUser.prototype['job_continuous_period'] = undefined;

/**
 * @member {module:model/Period} estimated_job_continuous_period
 */
AiOfferDraftItemUser.prototype['estimated_job_continuous_period'] = undefined;

/**
 * 推定勤続年数カテゴリが実値と異なる場合にtrue
 * @member {Boolean} is_job_continuous_period_estimated
 */
AiOfferDraftItemUser.prototype['is_job_continuous_period_estimated'] = undefined;

/**
 * @member {module:model/MoneyAmount} financial_asset
 */
AiOfferDraftItemUser.prototype['financial_asset'] = undefined;

/**
 * 年収
 * @member {Number} annual_income
 */
AiOfferDraftItemUser.prototype['annual_income'] = undefined;

/**
 * 保有物件数(登録時の申告数)
 * @member {Number} holding_property_count
 */
AiOfferDraftItemUser.prototype['holding_property_count'] = undefined;

/**
 * 保有物件数(アプリ内登録数)
 * @member {Number} registered_holding_property_count
 */
AiOfferDraftItemUser.prototype['registered_holding_property_count'] = undefined;

/**
 * 検討物件数(アプリ内登録数)
 * @member {Number} registered_considering_property_count
 */
AiOfferDraftItemUser.prototype['registered_considering_property_count'] = undefined;

/**
 * 不動産投資ローン残高合計
 * @member {Number} real_estate_loan_amount
 */
AiOfferDraftItemUser.prototype['real_estate_loan_amount'] = undefined;

/**
 * 現在のお住まいマスタデータID
 * @member {Number} current_residence_type_id
 */
AiOfferDraftItemUser.prototype['current_residence_type_id'] = undefined;

/**
 * 自宅毎月家賃額
 * @member {Number} monthly_rent_payment_amount
 */
AiOfferDraftItemUser.prototype['monthly_rent_payment_amount'] = undefined;

/**
 * 住宅ローン残債合計
 * @member {Number} home_loan_amount
 */
AiOfferDraftItemUser.prototype['home_loan_amount'] = undefined;

/**
 * @member {module:model/ConsiderationPeriodEnum} consideration_period
 */
AiOfferDraftItemUser.prototype['consideration_period'] = undefined;

/**
 * @member {module:model/PastMeetingCountEnum} past_meeting_count
 */
AiOfferDraftItemUser.prototype['past_meeting_count'] = undefined;

/**
 * 検討中の物件
 * @member {String} considering_property
 */
AiOfferDraftItemUser.prototype['considering_property'] = undefined;

/**
 * 承認済みの金融機関
 * @member {String} approved_financial_institutions
 */
AiOfferDraftItemUser.prototype['approved_financial_institutions'] = undefined;

/**
 * その他ご要望
 * @member {String} other_request_text
 */
AiOfferDraftItemUser.prototype['other_request_text'] = undefined;

/**
 * @member {module:model/RegisteredStatusEnum} data_first_registered_status
 */
AiOfferDraftItemUser.prototype['data_first_registered_status'] = undefined;

/**
 * 不動産会社からの提案希望 false:希望しない true:希望する 
 * @member {Boolean} request_the_proposal
 */
AiOfferDraftItemUser.prototype['request_the_proposal'] = undefined;

/**
 * 提案の連絡方法 0:メール 1:LINE 
 * @member {module:model/AiOfferDraftItemUser.WayToProposeEnum} way_to_propose
 */
AiOfferDraftItemUser.prototype['way_to_propose'] = undefined;

/**
 * @member {module:model/DegreeOfConsiderationEnum} degree_of_consideration_for_investment
 */
AiOfferDraftItemUser.prototype['degree_of_consideration_for_investment'] = undefined;

/**
 * @member {module:model/DegreeOfConsiderationEnum} degree_of_consideration_for_sale
 */
AiOfferDraftItemUser.prototype['degree_of_consideration_for_sale'] = undefined;

/**
 * @member {String} purpose_of_use_free_text
 */
AiOfferDraftItemUser.prototype['purpose_of_use_free_text'] = undefined;

/**
 * @member {String} inflow_route_free_text
 */
AiOfferDraftItemUser.prototype['inflow_route_free_text'] = undefined;

/**
 * @member {Boolean} email_confirmed
 */
AiOfferDraftItemUser.prototype['email_confirmed'] = undefined;

/**
 * @member {Number} last_seen_announcement_id
 */
AiOfferDraftItemUser.prototype['last_seen_announcement_id'] = undefined;

/**
 * @member {Boolean} has_unread_announcements
 */
AiOfferDraftItemUser.prototype['has_unread_announcements'] = undefined;

/**
 * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
 * @member {Boolean} is_diagnosis_complete
 */
AiOfferDraftItemUser.prototype['is_diagnosis_complete'] = undefined;

/**
 * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
 * @member {Boolean} is_investment_style_diagnosis_complete
 */
AiOfferDraftItemUser.prototype['is_investment_style_diagnosis_complete'] = undefined;

/**
 * 広告計測確認用の登録なら true（プランナー通知・事務局オファー・プランナー一覧・登録KPIから除外。広告成果送信は維持し、確認完了後にIDを指定して物理削除する）
 * @member {Boolean} is_ad_measurement_test
 */
AiOfferDraftItemUser.prototype['is_ad_measurement_test'] = undefined;

/**
 * @member {String} password
 */
AiOfferDraftItemUser.prototype['password'] = undefined;

/**
 * @member {String} password_confirmation
 */
AiOfferDraftItemUser.prototype['password_confirmation'] = undefined;

/**
 * @member {Date} withdrawal_intended_at
 */
AiOfferDraftItemUser.prototype['withdrawal_intended_at'] = undefined;

/**
 * @member {Date} last_accessed_at
 */
AiOfferDraftItemUser.prototype['last_accessed_at'] = undefined;

/**
 * ≒仮登録日
 * @member {Date} created_at
 */
AiOfferDraftItemUser.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AiOfferDraftItemUser.prototype['updated_at'] = undefined;

/**
 * @member {Date} account_updated_at
 */
AiOfferDraftItemUser.prototype['account_updated_at'] = undefined;

/**
 * 本登録日
 * @member {Date} account_registered_at
 */
AiOfferDraftItemUser.prototype['account_registered_at'] = undefined;

/**
 * @member {Date} discarded_at
 */
AiOfferDraftItemUser.prototype['discarded_at'] = undefined;

/**
 * @member {Date} first_match_at
 */
AiOfferDraftItemUser.prototype['first_match_at'] = undefined;

/**
 * @member {Number} read_offers_count
 */
AiOfferDraftItemUser.prototype['read_offers_count'] = undefined;

/**
 * 累計アクセス数（全月の合計）
 * @member {Number} total_access_count
 */
AiOfferDraftItemUser.prototype['total_access_count'] = undefined;

/**
 * 選択月のアクセス数
 * @member {Number} monthly_access_count
 */
AiOfferDraftItemUser.prototype['monthly_access_count'] = undefined;

/**
 * 選択月の日毎重複排除アクセス数
 * @member {Number} monthly_deduplication_access_count
 */
AiOfferDraftItemUser.prototype['monthly_deduplication_access_count'] = undefined;

/**
 * 累計マッチ数の合計
 * @member {Number} matched_count_sum
 */
AiOfferDraftItemUser.prototype['matched_count_sum'] = undefined;

/**
 * マッチ種別「ユーザ」の累計マッチ数
 * @member {Number} matched_count_user
 */
AiOfferDraftItemUser.prototype['matched_count_user'] = undefined;

/**
 * マッチ種別「投資」の累計マッチ数
 * @member {Number} matched_count_investment
 */
AiOfferDraftItemUser.prototype['matched_count_investment'] = undefined;

/**
 * マッチ種別「査定」の累計マッチ数
 * @member {Number} matched_count_assessment
 */
AiOfferDraftItemUser.prototype['matched_count_assessment'] = undefined;

/**
 * マッチ種別「手動」の累計マッチ数
 * @member {Number} matched_count_manual
 */
AiOfferDraftItemUser.prototype['matched_count_manual'] = undefined;

/**
 * 学習コンテンツ既読数
 * @member {Number} learning_completed_count
 */
AiOfferDraftItemUser.prototype['learning_completed_count'] = undefined;

/**
 * 学習進捗率（既読数/全記事数）
 * @member {Number} learning_progress_rate
 */
AiOfferDraftItemUser.prototype['learning_progress_rate'] = undefined;

/**
 * @member {String} adjust_network
 */
AiOfferDraftItemUser.prototype['adjust_network'] = undefined;

/**
 * @member {module:model/AdjustTracker} adjust_tracker
 */
AiOfferDraftItemUser.prototype['adjust_tracker'] = undefined;

/**
 * @member {module:model/ReferralRefEnum} referral_ref
 */
AiOfferDraftItemUser.prototype['referral_ref'] = undefined;

/**
 * 本登録日時(regular含む)
 * @member {Date} account_register_date
 */
AiOfferDraftItemUser.prototype['account_register_date'] = undefined;

/**
 * @member {Number} phone_number_auth_code
 */
AiOfferDraftItemUser.prototype['phone_number_auth_code'] = undefined;

/**
 * @member {Array.<module:model/AssessmentProposal>} assessment_proposals
 */
AiOfferDraftItemUser.prototype['assessment_proposals'] = undefined;

/**
 * @member {Array.<module:model/InvestmentProposal>} investment_proposals
 */
AiOfferDraftItemUser.prototype['investment_proposals'] = undefined;

/**
 * @member {Array.<module:model/ProposalMatching>} proposal_matchings
 */
AiOfferDraftItemUser.prototype['proposal_matchings'] = undefined;

/**
 * ユーザーがメッセージ詳細で「お断り」したプランナー（admin の fields=refusals で返す）
 * @member {Array.<module:model/AgentMessageRefusal>} agent_message_refusals
 */
AiOfferDraftItemUser.prototype['agent_message_refusals'] = undefined;

/**
 * @member {Array.<module:model/ContractApplication>} contract_applications
 */
AiOfferDraftItemUser.prototype['contract_applications'] = undefined;

/**
 * @member {module:model/AdminUserMemo} admin_user_memo
 */
AiOfferDraftItemUser.prototype['admin_user_memo'] = undefined;

/**
 * @member {Array.<module:model/Master>} master_tags
 */
AiOfferDraftItemUser.prototype['master_tags'] = undefined;

/**
 * @member {Array.<module:model/Master>} master_purpose_of_uses
 */
AiOfferDraftItemUser.prototype['master_purpose_of_uses'] = undefined;

/**
 * @member {Array.<module:model/Master>} master_interested_property_types
 */
AiOfferDraftItemUser.prototype['master_interested_property_types'] = undefined;

/**
 * 関心のあるタグIDリスト
 * @member {Array.<Number>} interest_tag_ids
 */
AiOfferDraftItemUser.prototype['interest_tag_ids'] = undefined;

/**
 * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
 * @member {Boolean} has_investment_experience
 */
AiOfferDraftItemUser.prototype['has_investment_experience'] = undefined;

/**
 * @member {Array.<module:model/Master>} master_inflow_routes
 */
AiOfferDraftItemUser.prototype['master_inflow_routes'] = undefined;

/**
 * @member {module:model/Master} current_residence_type
 */
AiOfferDraftItemUser.prototype['current_residence_type'] = undefined;

/**
 * 利用目的IDリスト
 * @member {Array.<Number>} purpose_of_use_ids
 */
AiOfferDraftItemUser.prototype['purpose_of_use_ids'] = undefined;

/**
 * 興味のある物件タイプIDリスト
 * @member {Array.<Number>} interested_property_type_ids
 */
AiOfferDraftItemUser.prototype['interested_property_type_ids'] = undefined;

/**
 * 流入経路IDリスト
 * @member {Array.<Number>} inflow_route_ids
 */
AiOfferDraftItemUser.prototype['inflow_route_ids'] = undefined;

/**
 * @member {module:model/UserDeviceToken} user_device_token
 */
AiOfferDraftItemUser.prototype['user_device_token'] = undefined;

/**
 * @member {Array.<module:model/UserAccessScreenLogMonthlySummary>} user_access_screen_log_monthly_summaries
 */
AiOfferDraftItemUser.prototype['user_access_screen_log_monthly_summaries'] = undefined;

/**
 * birthday から算出した年齢。birthday 未入力の場合は null
 * @member {Number} age
 */
AiOfferDraftItemUser.prototype['age'] = undefined;

/**
 * @member {Boolean} is_new_label
 */
AiOfferDraftItemUser.prototype['is_new_label'] = undefined;

/**
 * アクティブユーザーかどうか（最終ログインが3日以内）
 * @member {Boolean} is_active
 */
AiOfferDraftItemUser.prototype['is_active'] = undefined;

/**
 * @member {Boolean} is_favorite
 */
AiOfferDraftItemUser.prototype['is_favorite'] = undefined;

/**
 * ローン残高合計
 * @member {Number} loan_amount
 */
AiOfferDraftItemUser.prototype['loan_amount'] = undefined;


// Implement User interface:
/**
 * @member {Number} id
 */
User.prototype['id'] = undefined;
/**
 * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
 * @member {Number} score
 */
User.prototype['score'] = undefined;
/**
 * @member {String} identifier
 */
User.prototype['identifier'] = undefined;
/**
 * @member {String} family_name
 */
User.prototype['family_name'] = undefined;
/**
 * @member {String} first_name
 */
User.prototype['first_name'] = undefined;
/**
 * @member {String} family_name_kana
 */
User.prototype['family_name_kana'] = undefined;
/**
 * @member {String} first_name_kana
 */
User.prototype['first_name_kana'] = undefined;
/**
 * @member {Boolean} is_enabled_email_notification
 */
User.prototype['is_enabled_email_notification'] = undefined;
/**
 * @member {Boolean} is_enabled_sms_notification
 */
User.prototype['is_enabled_sms_notification'] = undefined;
/**
 * @member {Boolean} is_enabled_push_notification
 * @default true
 */
User.prototype['is_enabled_push_notification'] = true;
/**
 * @member {String} email
 */
User.prototype['email'] = undefined;
/**
 * @member {String} phone_number
 */
User.prototype['phone_number'] = undefined;
/**
 * @member {Date} birthday
 */
User.prototype['birthday'] = undefined;
/**
 * @member {Number} income_tax_rate
 */
User.prototype['income_tax_rate'] = undefined;
/**
 * @member {module:model/JobCategory} job_category
 */
User.prototype['job_category'] = undefined;
/**
 * 住所（都道府県）
 * @member {String} address_prefecture
 */
User.prototype['address_prefecture'] = undefined;
/**
 * @member {module:model/JobIndustry} job_industry
 */
User.prototype['job_industry'] = undefined;
/**
 * @member {module:model/Period} job_continuous_period
 */
User.prototype['job_continuous_period'] = undefined;
/**
 * @member {module:model/Period} estimated_job_continuous_period
 */
User.prototype['estimated_job_continuous_period'] = undefined;
/**
 * 推定勤続年数カテゴリが実値と異なる場合にtrue
 * @member {Boolean} is_job_continuous_period_estimated
 */
User.prototype['is_job_continuous_period_estimated'] = undefined;
/**
 * @member {module:model/MoneyAmount} financial_asset
 */
User.prototype['financial_asset'] = undefined;
/**
 * 年収
 * @member {Number} annual_income
 */
User.prototype['annual_income'] = undefined;
/**
 * 保有物件数(登録時の申告数)
 * @member {Number} holding_property_count
 */
User.prototype['holding_property_count'] = undefined;
/**
 * 保有物件数(アプリ内登録数)
 * @member {Number} registered_holding_property_count
 */
User.prototype['registered_holding_property_count'] = undefined;
/**
 * 検討物件数(アプリ内登録数)
 * @member {Number} registered_considering_property_count
 */
User.prototype['registered_considering_property_count'] = undefined;
/**
 * 不動産投資ローン残高合計
 * @member {Number} real_estate_loan_amount
 */
User.prototype['real_estate_loan_amount'] = undefined;
/**
 * 現在のお住まいマスタデータID
 * @member {Number} current_residence_type_id
 */
User.prototype['current_residence_type_id'] = undefined;
/**
 * 自宅毎月家賃額
 * @member {Number} monthly_rent_payment_amount
 */
User.prototype['monthly_rent_payment_amount'] = undefined;
/**
 * 住宅ローン残債合計
 * @member {Number} home_loan_amount
 */
User.prototype['home_loan_amount'] = undefined;
/**
 * @member {module:model/ConsiderationPeriodEnum} consideration_period
 */
User.prototype['consideration_period'] = undefined;
/**
 * @member {module:model/PastMeetingCountEnum} past_meeting_count
 */
User.prototype['past_meeting_count'] = undefined;
/**
 * 検討中の物件
 * @member {String} considering_property
 */
User.prototype['considering_property'] = undefined;
/**
 * 承認済みの金融機関
 * @member {String} approved_financial_institutions
 */
User.prototype['approved_financial_institutions'] = undefined;
/**
 * その他ご要望
 * @member {String} other_request_text
 */
User.prototype['other_request_text'] = undefined;
/**
 * @member {module:model/RegisteredStatusEnum} data_first_registered_status
 */
User.prototype['data_first_registered_status'] = undefined;
/**
 * 不動産会社からの提案希望 false:希望しない true:希望する 
 * @member {Boolean} request_the_proposal
 */
User.prototype['request_the_proposal'] = undefined;
/**
 * 提案の連絡方法 0:メール 1:LINE 
 * @member {module:model/User.WayToProposeEnum} way_to_propose
 */
User.prototype['way_to_propose'] = undefined;
/**
 * @member {module:model/DegreeOfConsiderationEnum} degree_of_consideration_for_investment
 */
User.prototype['degree_of_consideration_for_investment'] = undefined;
/**
 * @member {module:model/DegreeOfConsiderationEnum} degree_of_consideration_for_sale
 */
User.prototype['degree_of_consideration_for_sale'] = undefined;
/**
 * @member {String} purpose_of_use_free_text
 */
User.prototype['purpose_of_use_free_text'] = undefined;
/**
 * @member {String} inflow_route_free_text
 */
User.prototype['inflow_route_free_text'] = undefined;
/**
 * @member {Boolean} email_confirmed
 */
User.prototype['email_confirmed'] = undefined;
/**
 * @member {Number} last_seen_announcement_id
 */
User.prototype['last_seen_announcement_id'] = undefined;
/**
 * @member {Boolean} has_unread_announcements
 */
User.prototype['has_unread_announcements'] = undefined;
/**
 * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
 * @member {Boolean} is_diagnosis_complete
 */
User.prototype['is_diagnosis_complete'] = undefined;
/**
 * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
 * @member {Boolean} is_investment_style_diagnosis_complete
 */
User.prototype['is_investment_style_diagnosis_complete'] = undefined;
/**
 * 広告計測確認用の登録なら true（プランナー通知・事務局オファー・プランナー一覧・登録KPIから除外。広告成果送信は維持し、確認完了後にIDを指定して物理削除する）
 * @member {Boolean} is_ad_measurement_test
 */
User.prototype['is_ad_measurement_test'] = undefined;
/**
 * @member {String} password
 */
User.prototype['password'] = undefined;
/**
 * @member {String} password_confirmation
 */
User.prototype['password_confirmation'] = undefined;
/**
 * @member {Date} withdrawal_intended_at
 */
User.prototype['withdrawal_intended_at'] = undefined;
/**
 * @member {Date} last_accessed_at
 */
User.prototype['last_accessed_at'] = undefined;
/**
 * ≒仮登録日
 * @member {Date} created_at
 */
User.prototype['created_at'] = undefined;
/**
 * @member {Date} updated_at
 */
User.prototype['updated_at'] = undefined;
/**
 * @member {Date} account_updated_at
 */
User.prototype['account_updated_at'] = undefined;
/**
 * 本登録日
 * @member {Date} account_registered_at
 */
User.prototype['account_registered_at'] = undefined;
/**
 * @member {Date} discarded_at
 */
User.prototype['discarded_at'] = undefined;
/**
 * @member {Date} first_match_at
 */
User.prototype['first_match_at'] = undefined;
/**
 * @member {Number} read_offers_count
 */
User.prototype['read_offers_count'] = undefined;
/**
 * 累計アクセス数（全月の合計）
 * @member {Number} total_access_count
 */
User.prototype['total_access_count'] = undefined;
/**
 * 選択月のアクセス数
 * @member {Number} monthly_access_count
 */
User.prototype['monthly_access_count'] = undefined;
/**
 * 選択月の日毎重複排除アクセス数
 * @member {Number} monthly_deduplication_access_count
 */
User.prototype['monthly_deduplication_access_count'] = undefined;
/**
 * 累計マッチ数の合計
 * @member {Number} matched_count_sum
 */
User.prototype['matched_count_sum'] = undefined;
/**
 * マッチ種別「ユーザ」の累計マッチ数
 * @member {Number} matched_count_user
 */
User.prototype['matched_count_user'] = undefined;
/**
 * マッチ種別「投資」の累計マッチ数
 * @member {Number} matched_count_investment
 */
User.prototype['matched_count_investment'] = undefined;
/**
 * マッチ種別「査定」の累計マッチ数
 * @member {Number} matched_count_assessment
 */
User.prototype['matched_count_assessment'] = undefined;
/**
 * マッチ種別「手動」の累計マッチ数
 * @member {Number} matched_count_manual
 */
User.prototype['matched_count_manual'] = undefined;
/**
 * 学習コンテンツ既読数
 * @member {Number} learning_completed_count
 */
User.prototype['learning_completed_count'] = undefined;
/**
 * 学習進捗率（既読数/全記事数）
 * @member {Number} learning_progress_rate
 */
User.prototype['learning_progress_rate'] = undefined;
/**
 * @member {String} adjust_network
 */
User.prototype['adjust_network'] = undefined;
/**
 * @member {module:model/AdjustTracker} adjust_tracker
 */
User.prototype['adjust_tracker'] = undefined;
/**
 * @member {module:model/ReferralRefEnum} referral_ref
 */
User.prototype['referral_ref'] = undefined;
/**
 * 本登録日時(regular含む)
 * @member {Date} account_register_date
 */
User.prototype['account_register_date'] = undefined;
/**
 * @member {Number} phone_number_auth_code
 */
User.prototype['phone_number_auth_code'] = undefined;
/**
 * @member {Array.<module:model/AssessmentProposal>} assessment_proposals
 */
User.prototype['assessment_proposals'] = undefined;
/**
 * @member {Array.<module:model/InvestmentProposal>} investment_proposals
 */
User.prototype['investment_proposals'] = undefined;
/**
 * @member {Array.<module:model/ProposalMatching>} proposal_matchings
 */
User.prototype['proposal_matchings'] = undefined;
/**
 * ユーザーがメッセージ詳細で「お断り」したプランナー（admin の fields=refusals で返す）
 * @member {Array.<module:model/AgentMessageRefusal>} agent_message_refusals
 */
User.prototype['agent_message_refusals'] = undefined;
/**
 * @member {Array.<module:model/ContractApplication>} contract_applications
 */
User.prototype['contract_applications'] = undefined;
/**
 * @member {module:model/AdminUserMemo} admin_user_memo
 */
User.prototype['admin_user_memo'] = undefined;
/**
 * @member {Array.<module:model/Master>} master_tags
 */
User.prototype['master_tags'] = undefined;
/**
 * @member {Array.<module:model/Master>} master_purpose_of_uses
 */
User.prototype['master_purpose_of_uses'] = undefined;
/**
 * @member {Array.<module:model/Master>} master_interested_property_types
 */
User.prototype['master_interested_property_types'] = undefined;
/**
 * 関心のあるタグIDリスト
 * @member {Array.<Number>} interest_tag_ids
 */
User.prototype['interest_tag_ids'] = undefined;
/**
 * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
 * @member {Boolean} has_investment_experience
 */
User.prototype['has_investment_experience'] = undefined;
/**
 * @member {Array.<module:model/Master>} master_inflow_routes
 */
User.prototype['master_inflow_routes'] = undefined;
/**
 * @member {module:model/Master} current_residence_type
 */
User.prototype['current_residence_type'] = undefined;
/**
 * 利用目的IDリスト
 * @member {Array.<Number>} purpose_of_use_ids
 */
User.prototype['purpose_of_use_ids'] = undefined;
/**
 * 興味のある物件タイプIDリスト
 * @member {Array.<Number>} interested_property_type_ids
 */
User.prototype['interested_property_type_ids'] = undefined;
/**
 * 流入経路IDリスト
 * @member {Array.<Number>} inflow_route_ids
 */
User.prototype['inflow_route_ids'] = undefined;
/**
 * @member {module:model/UserDeviceToken} user_device_token
 */
User.prototype['user_device_token'] = undefined;
/**
 * @member {Array.<module:model/UserAccessScreenLogMonthlySummary>} user_access_screen_log_monthly_summaries
 */
User.prototype['user_access_screen_log_monthly_summaries'] = undefined;
/**
 * birthday から算出した年齢。birthday 未入力の場合は null
 * @member {Number} age
 */
User.prototype['age'] = undefined;
/**
 * @member {Boolean} is_new_label
 */
User.prototype['is_new_label'] = undefined;
/**
 * アクティブユーザーかどうか（最終ログインが3日以内）
 * @member {Boolean} is_active
 */
User.prototype['is_active'] = undefined;
/**
 * @member {Boolean} is_favorite
 */
User.prototype['is_favorite'] = undefined;
/**
 * ローン残高合計
 * @member {Number} loan_amount
 */
User.prototype['loan_amount'] = undefined;



/**
 * Allowed values for the <code>way_to_propose</code> property.
 * @enum {Number}
 * @readonly
 */
AiOfferDraftItemUser['WayToProposeEnum'] = {

    /**
     * value: 0
     * @const
     */
    "0": 0,

    /**
     * value: 1
     * @const
     */
    "1": 1
};



export default AiOfferDraftItemUser;

